import { useMutation, useQueryClient } from 'react-query';

import { userApi } from 'src/Services/API';
import { UserWithPrivateInfoDto } from 'src/Services/API/generated';

export const useMarkDemoPopupSeen = () => {
  const queryClient = useQueryClient();

  return useMutation(
    'mark-demo-popup-seen',
    async () => {
      await userApi.userControllerMarkDemoPopupSeen();
    },
    {
      onSuccess: () => {
        const current = queryClient.getQueryData<UserWithPrivateInfoDto>(['fetch-user']);
        if (current) {
          queryClient.setQueryData<UserWithPrivateInfoDto>(['fetch-user'], {
            ...current,
            hasSeenDemoPopup: true,
          });
        }
      },
    }
  );
};
